module.exports = __webpack_public_path__ + "img/AT.5b68188a.svg";